import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";

const requests = {
    fetch: (config: AxiosRequestConfig) => api.get(`/dashboard`, config),
};

export default requests;
